export default "__VITE_ASSET__CfR$l89u__"